import axiosInstance from "../../config/Axios";

export const getAdjustments = async (filters = {}) => {
  try {
    return await axiosInstance({
      method: "get",
      url: "/api/feedback/adjustments/",
      params: filters,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAdjustmentById = async (id) => {
  try {
    return await axiosInstance({
      method: "get",
      url: `/api/feedback/adjustments/${id}/`,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createAdjustment = async (adjustmentData) => {
  try {
    return await axiosInstance({
      method: "post",
      url: "/api/feedback/adjustments/",
      data: adjustmentData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateAdjustment = async (id, adjustmentData) => {
  try {
    return await axiosInstance({
      method: "put",
      url: `/api/feedback/adjustments/${id}/`,
      data: adjustmentData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteAdjustment = async (id) => {
  if (!id) {
    return Promise.reject(new Error("Adjustment ID is required"));
  }
  try {
    const response = await axiosInstance({
      method: "delete",
      url: `/api/feedback/adjustments/${id}/`,
    });
    return response;
  } catch (error) {
    console.error("Delete API Error:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
};

export default {
  getAdjustments,
  getAdjustmentById,
  createAdjustment,
  updateAdjustment,
  deleteAdjustment,
};
